export const enum ContainerMessageType {
  EXIT = 'EXIT',
}

export type ContainerMessage = ContainerMessageExit

export type ContainerMessageExit = {
  type: ContainerMessageType.EXIT
  payload: object
}
